import {RadioModel} from "../../../personal-data/model/radio.model";
import {DomainOrigin} from "./model/domain-origin";
import {DomainDataType} from "./model/domain-data-type";

export class DomainUtil{

  public static getDomainFromCache(origin: DomainOrigin, type: DomainDataType, param?: string): RadioModel[]{
    try{
      const storageName = origin + '-' + type + (param?param:'');
      return JSON.parse(localStorage.getItem(storageName));
    }
    catch (err){
      return [];
    }
  }

  public static saveDomainInCache(origin: DomainOrigin, type: DomainDataType, data: RadioModel[], param?: string): void{
    localStorage.setItem((origin + '-' + type + (param?param:'')), JSON.stringify(data));
  }


}
